
<div class="scroll-body">
  <app-header></app-header>
  <main class="app-content">
    <router-outlet></router-outlet>
  </main>
</div>

<app-footer></app-footer>
